import http from "../http";

const HistoryService = {

    getNetlineSyncHistData_Service:async()=>
    {
        const resp = await http.instance.get("/TechnicalHistory/getNetlineSyncHistData/");
        console.log(resp.data)
        return resp.data;
    },

    getNetlineChangeHistoryOriginService: async(STD) =>
    {
        const NetlineChangeVersions = await http.instance.get("/TechnicalHistory/getNetlineChangeHistDataByStd/",{params:{STD:STD}});

        return NetlineChangeVersions.data;
        // return [
        //     {
        //         "ID": 609663,
        //         "LEG_NO": 382206,
        //         "FACTION": 2,
        //         "HIS_DT": "01/06/2023 3:00",
        //         "CREATEDT": "01/06/2023 3:00",
        //         "MODIFYDATE": "01/06/2023 3:00",
        //         "STD": "01/08/2023 8:15",
        //         "STA": "01/08/2023 9:45",
        //         "ATD": "01/08/2023 8:15",
        //         "ATA": "01/08/2023 9:45",
        //         "CARRIER": "CAI",
        //         "FNO": 440,
        //         "FNO7_WITH_SFX": 440,
        //         "CALLSIGN": " ",
        //         "SDEP": "TLV",
        //         "SARR": "AYT",
        //         "ADEP": "TLV",
        //         "AARR": "AYT",
        //         "DIS_DTYPE": "NULL",
        //         "DIS_DT": "NULL",
        //         "SDEP_ICAO": "LLBG",
        //         "SARR_ICAO": "LTAI",
        //         "ADEP_ICAO": "LLBG",
        //         "AARR_ICAO": "LTAI",
        //         "ACREG": "XXXXX",
        //         "LEG_TYPE": "C",
        //         "LEG_STATE": "SKD",
        //         "AC_OWNER": "CAI",
        //         "TARIH": "01/08/2023 0:00",
        //         "UPDATEKEY": 436439623,
        //         "CP1": "CCS",
        //         "CP2": "SOM",
        //         "CabinList": "EGT ANR AHB BZT ",
        //         "ManuelUpdate": 0,
        //         "WhoDidManual": "NULL",
        //         "WhenDidManual": "01/01/1900 0:00",
        //         "FKeyForZip": "XXXXX_CAI440_20230108_LLBG_LTAI",
        //         "NLVT": 1,
        //         "FKeyForNetline": "XXXXX_CAI440_20230108_LLBG_LTAI001",
        //         "LastSync": "01/06/2023 3:00",
        //         "LastChangeInfo": "C",
        //         "OTHER_PARAMS_TEXT": "CCS|CAI|0|CAN  CETINSAYA|1923|1040|TR|M|19890202|20150713|20351231|ééSOM|CAI|1|SEMIH  OZMEN|3200|1122|TR|M|19910423|20191216|20351231|éé",
        //         "CntJ": 0,
        //         "JKFZ": "XXXXX_CAI440_20230108_LLBG_LTAI",
        //         "JLVT_RANGE": "NULL"
        //     },
        //     {
        //         "ID": 609713,
        //         "LEG_NO": 382207,
        //         "FACTION": 2,
        //         "HIS_DT": "01/06/2023 3:00",
        //         "CREATEDT": "01/06/2023 3:00",
        //         "MODIFYDATE": "01/06/2023 3:00",
        //         "STD": "01/08/2023 19:30",
        //         "STA": "01/08/2023 21:00",
        //         "ATD": "01/08/2023 19:30",
        //         "ATA": "01/08/2023 21:00",
        //         "CARRIER": "CAI",
        //         "FNO": 441,
        //         "FNO7_WITH_SFX": 441,
        //         "CALLSIGN": " ",
        //         "SDEP": "AYT",
        //         "SARR": "TLV",
        //         "ADEP": "AYT",
        //         "AARR": "TLV",
        //         "DIS_DTYPE": "NULL",
        //         "DIS_DT": "NULL",
        //         "SDEP_ICAO": "LTAI",
        //         "SARR_ICAO": "LLBG",
        //         "ADEP_ICAO": "LTAI",
        //         "AARR_ICAO": "LLBG",
        //         "ACREG": "XXXXX",
        //         "LEG_TYPE": "C",
        //         "LEG_STATE": "SKD",
        //         "AC_OWNER": "CAI",
        //         "TARIH": "01/08/2023 0:00",
        //         "UPDATEKEY": 436320002,
        //         "CP1": "AUL",
        //         "CP2": "GAC",
        //         "CabinList": "MSN CNN ERC EKN ",
        //         "ManuelUpdate": 0,
        //         "WhoDidManual": "NULL",
        //         "WhenDidManual": "01/01/1900 0:00",
        //         "FKeyForZip": "XXXXX_CAI441_20230108_LTAI_LLBG",
        //         "NLVT": 1,
        //         "FKeyForNetline": "XXXXX_CAI441_20230108_LTAI_LLBG001",
        //         "LastSync": "01/06/2023 3:00",
        //         "LastChangeInfo": "C",
        //         "OTHER_PARAMS_TEXT": "AUL|CAI|0|AHMET  ULKEN|1019|78|TR|M|19801114|20170605|20351231|ééGAC|CAI|1|GOKHAN  ACER|3369|1173|TR|M|19901217|20220124|20351231|éé",
        //         "CntJ": 0,
        //         "JKFZ": "XXXXX_CAI441_20230108_LTAI_LLBG",
        //         "JLVT_RANGE": "NULL"
        //     },
        //     {
        //         "ID": 609714,
        //         "LEG_NO": 382210,
        //         "FACTION": 2,
        //         "HIS_DT": "01/06/2023 3:00",
        //         "CREATEDT": "01/06/2023 3:00",
        //         "MODIFYDATE": "01/06/2023 3:00",
        //         "STD": "01/08/2023 3:10",
        //         "STA": "01/08/2023 4:55",
        //         "ATD": "01/08/2023 3:10",
        //         "ATA": "01/08/2023 4:55",
        //         "CARRIER": "CAI",
        //         "FNO": 805,
        //         "SUFFIX": "A",
        //         "FNO7_WITH_SFX": "000805A",
        //         "CALLSIGN": " ",
        //         "SDEP": "SSH",
        //         "SARR": "AYT",
        //         "ADEP": "SSH",
        //         "AARR": "AYT",
        //         "DIS_DTYPE": "NULL",
        //         "DIS_DT": "NULL",
        //         "SDEP_ICAO": "HESH",
        //         "SARR_ICAO": "LTAI",
        //         "ADEP_ICAO": "HESH",
        //         "AARR_ICAO": "LTAI",
        //         "ACREG": "XXXXX",
        //         "LEG_TYPE": "C",
        //         "LEG_STATE": "SKD",
        //         "AC_OWNER": "CAI",
        //         "TARIH": "01/08/2023 0:00",
        //         "UPDATEKEY": 436439623,
        //         "CP1": "SKN",
        //         "CP2": "IOO",
        //         "CabinList": "KEK NZM AEU CCI ",
        //         "ManuelUpdate": 0,
        //         "WhoDidManual": "NULL",
        //         "WhenDidManual": "01/01/1900 0:00",
        //         "FKeyForZip": "XXXXX_CAI805A_20230108_HESH_LTAI",
        //         "NLVT": 1,
        //         "FKeyForNetline": "XXXXX_CAI805A_20230108_HESH_LTAI001",
        //         "LastSync": "01/06/2023 3:00",
        //         "LastChangeInfo": "C",
        //         "OTHER_PARAMS_TEXT": "SKN|CAI|0|SERKAN  AYDEMIR|796|76|TR|M|19760515|20110401|20351231|ééIOO|CAI|1|IRFAN OZAN  ONGUN|2047|1043|TR|M|19820925|20160413|20351231|éé",
        //         "CntJ": 0,
        //         "JKFZ": "XXXXX_CAI805_20230108_HESH_LTAI",
        //         "JLVT_RANGE": "NULL"
        //     },
        //     {
        //         "ID": 609688,
        //         "LEG_NO": 382211,
        //         "FACTION": 2,
        //         "HIS_DT": "01/06/2023 3:00",
        //         "CREATEDT": "01/06/2023 3:00",
        //         "MODIFYDATE": "01/06/2023 3:00",
        //         "STD": "01/08/2023 5:15",
        //         "STA": "01/08/2023 9:55",
        //         "ATD": "01/08/2023 5:15",
        //         "ATA": "01/08/2023 9:55",
        //         "CARRIER": "CAI",
        //         "FNO": 805,
        //         "SUFFIX": "B",
        //         "FNO7_WITH_SFX": "000805B",
        //         "CALLSIGN": " ",
        //         "SDEP": "AYT",
        //         "SARR": "UFA",
        //         "ADEP": "AYT",
        //         "AARR": "UFA",
        //         "DIS_DTYPE": "NULL",
        //         "DIS_DT": "NULL",
        //         "SDEP_ICAO": "LTAI",
        //         "SARR_ICAO": "UWUU",
        //         "ADEP_ICAO": "LTAI",
        //         "AARR_ICAO": "UWUU",
        //         "ACREG": "XXXXX",
        //         "LEG_TYPE": "J",
        //         "LEG_STATE": "SKD",
        //         "AC_OWNER": "CAI",
        //         "TARIH": "01/08/2023 0:00",
        //         "UPDATEKEY": 436439623,
        //         "CP1": "HSU",
        //         "CP2": "IMG",
        //         "CabinList": "VST ASE ASN SUD ",
        //         "ManuelUpdate": 0,
        //         "WhoDidManual": "NULL",
        //         "WhenDidManual": "01/01/1900 0:00",
        //         "FKeyForZip": "XXXXX_CAI805B_20230108_LTAI_UWUU",
        //         "NLVT": 1,
        //         "FKeyForNetline": "XXXXX_CAI805B_20230108_LTAI_UWUU001",
        //         "LastSync": "01/06/2023 3:00",
        //         "LastChangeInfo": "C",
        //         "OTHER_PARAMS_TEXT": "HSU|CAI|0|HUSEYIN  SURMELI|3000|105|TR|M|19680218|20190429|20280218|ééIMG|CAI|1|IZZET METE  GUNDEM|3372|1176|TR|M|19890228|20220124|20351231|éé",
        //         "CntJ": 0,
        //         "JKFZ": "XXXXX_CAI805_20230108_LTAI_UWUU",
        //         "JLVT_RANGE": "NULL"
        //     },
        //     {
        //         "ID": 609737,
        //         "LEG_NO": 382212,
        //         "FACTION": 2,
        //         "HIS_DT": "01/06/2023 3:00",
        //         "CREATEDT": "01/06/2023 3:00",
        //         "MODIFYDATE": "01/06/2023 3:00",
        //         "STD": "01/08/2023 10:50",
        //         "STA": "01/08/2023 16:00",
        //         "ATD": "01/08/2023 10:50",
        //         "ATA": "01/08/2023 16:00",
        //         "CARRIER": "CAI",
        //         "FNO": 806,
        //         "SUFFIX": "B",
        //         "FNO7_WITH_SFX": "000806B",
        //         "CALLSIGN": " ",
        //         "SDEP": "UFA",
        //         "SARR": "AYT",
        //         "ADEP": "UFA",
        //         "AARR": "AYT",
        //         "DIS_DTYPE": "NULL",
        //         "DIS_DT": "NULL",
        //         "SDEP_ICAO": "UWUU",
        //         "SARR_ICAO": "LTAI",
        //         "ADEP_ICAO": "UWUU",
        //         "AARR_ICAO": "LTAI",
        //         "ACREG": "XXXXX",
        //         "LEG_TYPE": "J",
        //         "LEG_STATE": "SKD",
        //         "AC_OWNER": "CAI",
        //         "TARIH": "01/08/2023 0:00",
        //         "UPDATEKEY": 436439623,
        //         "CP1": "HSU",
        //         "CP2": "IMG",
        //         "CabinList": "VST ASE ASN SUD ",
        //         "ManuelUpdate": 0,
        //         "WhoDidManual": "NULL",
        //         "WhenDidManual": "01/01/1900 0:00",
        //         "FKeyForZip": "XXXXX_CAI806B_20230108_UWUU_LTAI",
        //         "NLVT": 1,
        //         "FKeyForNetline": "XXXXX_CAI806B_20230108_UWUU_LTAI001",
        //         "LastSync": "01/06/2023 3:00",
        //         "LastChangeInfo": "C",
        //         "OTHER_PARAMS_TEXT": "HSU|CAI|0|HUSEYIN  SURMELI|3000|105|TR|M|19680218|20190429|20280218|ééIMG|CAI|1|IZZET METE  GUNDEM|3372|1176|TR|M|19890228|20220124|20351231|éé",
        //         "CntJ": 0,
        //         "JKFZ": "XXXXX_CAI806_20230108_UWUU_LTAI",
        //         "JLVT_RANGE": "NULL"
        //     },
        //     {
        //         "ID": 609710,
        //         "LEG_NO": 382213,
        //         "FACTION": 2,
        //         "HIS_DT": "01/06/2023 3:00",
        //         "CREATEDT": "01/06/2023 3:00",
        //         "MODIFYDATE": "01/06/2023 3:00",
        //         "STD": "01/08/2023 16:20",
        //         "STA": "01/08/2023 18:20",
        //         "ATD": "01/08/2023 16:20",
        //         "ATA": "01/08/2023 18:20",
        //         "CARRIER": "CAI",
        //         "FNO": 806,
        //         "SUFFIX": "A",
        //         "FNO7_WITH_SFX": "000806A",
        //         "CALLSIGN": " ",
        //         "SDEP": "AYT",
        //         "SARR": "SSH",
        //         "ADEP": "AYT",
        //         "AARR": "SSH",
        //         "DIS_DTYPE": "NULL",
        //         "DIS_DT": "NULL",
        //         "SDEP_ICAO": "LTAI",
        //         "SARR_ICAO": "HESH",
        //         "ADEP_ICAO": "LTAI",
        //         "AARR_ICAO": "HESH",
        //         "ACREG": "XXXXX",
        //         "LEG_TYPE": "C",
        //         "LEG_STATE": "SKD",
        //         "AC_OWNER": "CAI",
        //         "TARIH": "01/08/2023 0:00",
        //         "UPDATEKEY": 436439623,
        //         "CP1": "EKB",
        //         "CP2": "EMT",
        //         "CabinList": "YTP GKL BRE MFT ",
        //         "ManuelUpdate": 0,
        //         "WhoDidManual": "NULL",
        //         "WhenDidManual": "01/01/1900 0:00",
        //         "FKeyForZip": "XXXXX_CAI806A_20230108_LTAI_HESH",
        //         "NLVT": 1,
        //         "FKeyForNetline": "XXXXX_CAI806A_20230108_LTAI_HESH001",
        //         "LastSync": "01/06/2023 3:00",
        //         "LastChangeInfo": "C",
        //         "OTHER_PARAMS_TEXT": "EKB|CAI|0|EKBER  AKBULUT|3326|134|TR|M|19710215|20210705|20310215|ééEMT|CAI|1|EYYUP MIRAC  TERCANLI|3201|1123|TR|M|19920123|20191216|20351231|éé",
        //         "CntJ": 0,
        //         "JKFZ": "XXXXX_CAI806_20230108_LTAI_HESH",
        //         "JLVT_RANGE": "NULL"
        //     },
        //     {
        //         "ID": 609705,
        //         "LEG_NO": 382216,
        //         "FACTION": 2,
        //         "HIS_DT": "01/06/2023 3:00",
        //         "CREATEDT": "01/06/2023 3:00",
        //         "MODIFYDATE": "01/06/2023 3:00",
        //         "STD": "01/08/2023 3:50",
        //         "STA": "01/08/2023 5:55",
        //         "ATD": "01/08/2023 3:50",
        //         "ATA": "01/08/2023 5:55",
        //         "CARRIER": "CAI",
        //         "FNO": 977,
        //         "SUFFIX": "A",
        //         "FNO7_WITH_SFX": "000977A",
        //         "CALLSIGN": " ",
        //         "SDEP": "HRG",
        //         "SARR": "AYT",
        //         "ADEP": "HRG",
        //         "AARR": "AYT",
        //         "DIS_DTYPE": "NULL",
        //         "DIS_DT": "NULL",
        //         "SDEP_ICAO": "HEGN",
        //         "SARR_ICAO": "LTAI",
        //         "ADEP_ICAO": "HEGN",
        //         "AARR_ICAO": "LTAI",
        //         "ACREG": "XXXXX",
        //         "LEG_TYPE": "C",
        //         "LEG_STATE": "SKD",
        //         "AC_OWNER": "CAI",
        //         "TARIH": "01/08/2023 0:00",
        //         "UPDATEKEY": 436439623,
        //         "CP1": "ZGO",
        //         "CP2": "OZE",
        //         "CabinList": "EFE FTO CKR LYN ",
        //         "ManuelUpdate": 0,
        //         "WhoDidManual": "NULL",
        //         "WhenDidManual": "01/01/1900 0:00",
        //         "FKeyForZip": "XXXXX_CAI977A_20230108_HEGN_LTAI",
        //         "NLVT": 1,
        //         "FKeyForNetline": "XXXXX_CAI977A_20230108_HEGN_LTAI001",
        //         "LastSync": "01/06/2023 3:00",
        //         "LastChangeInfo": "C",
        //         "OTHER_PARAMS_TEXT": "ZGO|CAI|0|ZEKAI  GOL|2815|84|TR|M|19710106|20181119|20310106|ééOZE|CAI|1|OZCAN  ERDEMIR|2793|1084|TR|M|19710310|20181022|20310110|éé",
        //         "CntJ": 0,
        //         "JKFZ": "XXXXX_CAI977_20230108_HEGN_LTAI",
        //         "JLVT_RANGE": "NULL"
        //     },
        //     {
        //         "ID": 609678,
        //         "LEG_NO": 382217,
        //         "FACTION": 2,
        //         "HIS_DT": "01/06/2023 3:00",
        //         "CREATEDT": "01/06/2023 3:00",
        //         "MODIFYDATE": "01/06/2023 3:00",
        //         "STD": "01/08/2023 6:15",
        //         "STA": "01/08/2023 11:00",
        //         "ATD": "01/08/2023 6:15",
        //         "ATA": "01/08/2023 11:00",
        //         "CARRIER": "CAI",
        //         "FNO": 977,
        //         "SUFFIX": "B",
        //         "FNO7_WITH_SFX": "000977B",
        //         "CALLSIGN": " ",
        //         "SDEP": "AYT",
        //         "SARR": "GOJ",
        //         "ADEP": "AYT",
        //         "AARR": "GOJ",
        //         "DIS_DTYPE": "NULL",
        //         "DIS_DT": "NULL",
        //         "SDEP_ICAO": "LTAI",
        //         "SARR_ICAO": "UWGG",
        //         "ADEP_ICAO": "LTAI",
        //         "AARR_ICAO": "UWGG",
        //         "ACREG": "XXXXX",
        //         "LEG_TYPE": "J",
        //         "LEG_STATE": "SKD",
        //         "AC_OWNER": "CAI",
        //         "TARIH": "01/08/2023 0:00",
        //         "UPDATEKEY": 436439623,
        //         "CP1": "DSO",
        //         "CP2": "OYI",
        //         "CabinList": "LIF EKK OGL YDD ",
        //         "ManuelUpdate": 0,
        //         "WhoDidManual": "NULL",
        //         "WhenDidManual": "01/01/1900 0:00",
        //         "FKeyForZip": "XXXXX_CAI977B_20230108_LTAI_UWGG",
        //         "NLVT": 1,
        //         "FKeyForNetline": "XXXXX_CAI977B_20230108_LTAI_UWGG001",
        //         "LastSync": "01/06/2023 3:00",
        //         "LastChangeInfo": "C",
        //         "OTHER_PARAMS_TEXT": "DSO|CAI|0|DOGAN  SONAY|3441|160|TR|M|19661011|20220321|20310215|ééOYI|CAI|1|OZAN  YILDIZ|3377|1181|TR|M|19941025|20220124|20351231|éé",
        //         "CntJ": 0,
        //         "JKFZ": "XXXXX_CAI977_20230108_LTAI_UWGG",
        //         "JLVT_RANGE": "NULL"
        //     },
        //     {
        //         "ID": 609727,
        //         "LEG_NO": 382218,
        //         "FACTION": 2,
        //         "HIS_DT": "01/06/2023 3:00",
        //         "CREATEDT": "01/06/2023 3:00",
        //         "MODIFYDATE": "01/06/2023 3:00",
        //         "STD": "01/08/2023 12:00",
        //         "STA": "01/08/2023 17:20",
        //         "ATD": "01/08/2023 12:00",
        //         "ATA": "01/08/2023 17:20",
        //         "CARRIER": "CAI",
        //         "FNO": 978,
        //         "SUFFIX": "B",
        //         "FNO7_WITH_SFX": "000978B",
        //         "CALLSIGN": " ",
        //         "SDEP": "GOJ",
        //         "SARR": "AYT",
        //         "ADEP": "GOJ",
        //         "AARR": "AYT",
        //         "DIS_DTYPE": "NULL",
        //         "DIS_DT": "NULL",
        //         "SDEP_ICAO": "UWGG",
        //         "SARR_ICAO": "LTAI",
        //         "ADEP_ICAO": "UWGG",
        //         "AARR_ICAO": "LTAI",
        //         "ACREG": "XXXXX",
        //         "LEG_TYPE": "J",
        //         "LEG_STATE": "SKD",
        //         "AC_OWNER": "CAI",
        //         "TARIH": "01/08/2023 0:00",
        //         "UPDATEKEY": 436439623,
        //         "CP1": "DSO",
        //         "CP2": "OYI",
        //         "CabinList": "LIF EKK OGL YDD ",
        //         "ManuelUpdate": 0,
        //         "WhoDidManual": "NULL",
        //         "WhenDidManual": "01/01/1900 0:00",
        //         "FKeyForZip": "XXXXX_CAI978B_20230108_UWGG_LTAI",
        //         "NLVT": 1,
        //         "FKeyForNetline": "XXXXX_CAI978B_20230108_UWGG_LTAI001",
        //         "LastSync": "01/06/2023 3:00",
        //         "LastChangeInfo": "C",
        //         "OTHER_PARAMS_TEXT": "DSO|CAI|0|DOGAN  SONAY|3441|160|TR|M|19661011|20220321|20310215|ééOYI|CAI|1|OZAN  YILDIZ|3377|1181|TR|M|19941025|20220124|20351231|éé",
        //         "CntJ": 0,
        //         "JKFZ": "XXXXX_CAI978_20230108_UWGG_LTAI",
        //         "JLVT_RANGE": "NULL"
        //     },
        //     {
        //         "ID": 609699,
        //         "LEG_NO": 382219,
        //         "FACTION": 2,
        //         "HIS_DT": "01/06/2023 3:00",
        //         "CREATEDT": "01/06/2023 3:00",
        //         "MODIFYDATE": "01/06/2023 3:00",
        //         "STD": "01/08/2023 17:40",
        //         "STA": "01/08/2023 19:40",
        //         "ATD": "01/08/2023 17:40",
        //         "ATA": "01/08/2023 19:40",
        //         "CARRIER": "CAI",
        //         "FNO": 978,
        //         "SUFFIX": "A",
        //         "FNO7_WITH_SFX": "000978A",
        //         "CALLSIGN": " ",
        //         "SDEP": "AYT",
        //         "SARR": "HRG",
        //         "ADEP": "AYT",
        //         "AARR": "HRG",
        //         "DIS_DTYPE": "NULL",
        //         "DIS_DT": "NULL",
        //         "SDEP_ICAO": "LTAI",
        //         "SARR_ICAO": "HEGN",
        //         "ADEP_ICAO": "LTAI",
        //         "AARR_ICAO": "HEGN",
        //         "ACREG": "XXXXX",
        //         "LEG_TYPE": "C",
        //         "LEG_STATE": "SKD",
        //         "AC_OWNER": "CAI",
        //         "TARIH": "01/08/2023 0:00",
        //         "UPDATEKEY": 436439623,
        //         "CP1": "GDE",
        //         "CP2": "BAU",
        //         "CabinList": "ZLB ABT YOZ SAG ",
        //         "ManuelUpdate": 0,
        //         "WhoDidManual": "NULL",
        //         "WhenDidManual": "01/01/1900 0:00",
        //         "FKeyForZip": "XXXXX_CAI978A_20230108_LTAI_HEGN",
        //         "NLVT": 1,
        //         "FKeyForNetline": "XXXXX_CAI978A_20230108_LTAI_HEGN001",
        //         "LastSync": "01/06/2023 3:00",
        //         "LastChangeInfo": "C",
        //         "OTHER_PARAMS_TEXT": "GDE|CAI|0|GUNGOR  DEMIRKOL|2816|85|TR|M|19710705|20181119|20310705|ééBAU|CAI|1|BUGRA ARIF  UCKU|2364|1054|TR|M|19790730|20170424|20351231|éé",
        //         "CntJ": 0,
        //         "JKFZ": "XXXXX_CAI978_20230108_LTAI_HEGN",
        //         "JLVT_RANGE": "NULL"
        //     }
        // ];
    },

    getTransferSummaryVersions: async (FKeyForZip) =>
    {
        const SummaryVersions = await http.instance.get("/TechnicalHistory/GetTransferSummaryVersions/",{params:{FKeyForZip:FKeyForZip}});
        return SummaryVersions.data;
    },

    getTransferSummaryVersionsByLegno: async (LegNo) =>
    {

        const SummaryVersions = await http.instance.get("/TechnicalHistory/GetTransferSummaryVersionsByLegNo/",{params:{LegNo:LegNo}});
        return SummaryVersions.data;

    },

    getNetlineChangeHistoryByLegNoService: async(LegNo) =>
    {

        const NetlineChangeVersions = await http.instance.get("/TechnicalHistory/GetNetline_History_GetAllChangesByLegNo/",{params:{LegNo:LegNo}});
        return NetlineChangeVersions.data;
    },

    GetWrJson : async (KFZ,STD,WLVT,archiveStat) =>
    {
        // alert("history service"+KFZ+STD+WLVT+archiveStat)
        const JRJsonData = await http.instance.get("/TechnicalHistory/GetWRjson/",{
            params :
                {
                    KFZ : KFZ,
                    STD : STD,
                    WLVT : WLVT,
                    ArchiveId : archiveStat
                }
        })
        return JRJsonData.data;
    },

    //archiveStat
    GetEffJson : async (KFZ,STD,JLVT,archiveStat) =>
    {
        // alert("history service GetEffJson"+ archiveStat)
        const EffJson = await http.instance.get("/TechnicalHistory/GetJRjson/",
        {
            params :
                {
                    KFZ : KFZ,
                    STD : STD,
                    JLVT : JLVT,
                    ArchiveId : archiveStat
                }
        })
        return EffJson.data;
    },

    ForceUpdate : async (SelectedJSummaryId,isForceManually) =>
    {
        //console.log("Forceupdate before put api: "+ SelectedJSummaryId + " "+isForceManually);
        const forceManuallyModel = new FormData();

        if (isForceManually == 1)
        {
            isForceManually = true;
        }
        else
        {
            isForceManually = false;
        }
        //console.log("Forceupdate before put api: "+ SelectedJSummaryId + " "+isForceManually);
        //forceManuallyModel.set("Stat" , 1);
        //forceManuallyModel.set("message" , "test");
        forceManuallyModel.set("IsForcedManually" , isForceManually);
        forceManuallyModel.set("JSummaryId", SelectedJSummaryId);

        const result = await http.instance.post("/TechnicalHistory/ForceManuallyUpdate/", forceManuallyModel);
            // parametre başarılı birşekilde işlendi...
        //const result = http.instance.post("/TechnicalHistory/ForceManuallyUpdate/", forceManuallyModel);
        return result.data;
    },

    GetForceManuallyStat : async (SelectedJSummaryId) =>
    {
        //console.log(SelectedJSummaryId + "getforcemanually için stat geldimi ");

        const result = await http.instance.get("/TechnicalHistory/ForceManuallyGetStatus",{params:{JSummaryId:SelectedJSummaryId}});

        return result.data;
    },

    GetList_JetplanWaitingRequests : async ()  =>
    {
        const result = await http.instance.get("/TechnicalHistory/GetList_JetplanWaitingRequests");

        return result.data;
    },




};

export default HistoryService;
